import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    // Gets ALL scheduled events for the user, across ALL missions
    index: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "/scheduled_events/future_events";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

}